import axios from 'axios'
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import io from 'socket.io-client'
const socket = io({
    reconnectionDelayMax: 10000,
    transports:   ['websocket']
});

export { socket, axios }
